import { render } from "./MarkenBoxenMedia.vue?vue&type=template&id=107384fb"
import script from "./MarkenBoxenMedia.vue?vue&type=script&lang=ts"
export * from "./MarkenBoxenMedia.vue?vue&type=script&lang=ts"

import "./MarkenBoxenMedia.vue?vue&type=style&index=0&id=107384fb&lang=scss"
script.render = render

export default script